import { type JSX } from 'react'
import { Outlet } from 'react-router'
import RequireClientAuth from '../auth/RequireClientAuth.js'

export default function ClientPortalProtectedLayout(): JSX.Element {
  return (
    <RequireClientAuth>
      <Outlet />
    </RequireClientAuth>
  )
}
